import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { objectsDefListSelector } from '../../../reducers/objectReducers/objectSelector';
import { getObjectDefField } from '../../Utils/Utils';
import DataCellByType from './onGetDataCellByType';
import { selectDisplayModel } from '../../../reducers/layoutReducer/displayModel';

function DataColumns({ node }) {
  const objectsDefList = useSelector(objectsDefListSelector);

  const { calculatedDisplayMode, fusedDataColumns } =
    useSelector(selectDisplayModel);
  const calcDM = calculatedDisplayMode;
  const dataColumns = fusedDataColumns;

  const isStack = calcDM[node.depth - 1] === 'stack';
  const isGrid = calcDM[node.depth - 1] === 'grid';
  const index = node.depth - 1;

  let filteredDataColumns =
    isGrid || isStack
      ? // ? dataColumns?.[index]?.filter((col) =>
        //     objectType.toLowerCase().startsWith(col.to)
        //   )
        // : [];
        dataColumns?.[index]?.filter((col) => true)
      : [];

  return (
    <>
      {filteredDataColumns
        // ?.filter((a) => node.data.type.toLowerCase().startsWith(a.to))
        .map((item, ind, arr) => {
          const isLastCell = ind === arr.length - 1;
          const result = (
            <DataCellByType
              key={`${node?.data?.key}${ind}`}
              item={item}
              node={node}
              isStacked={isStack}
              id={`${node?.data?.key}${ind}`}
              panelNumber={node.depth - 1}
              colNumber={ind}
              isLastCell={isLastCell}
              typeTo={item.to}
              name={item.data}
            />
          );

          return result;
        })}
    </>
  );
}

export default memo(DataColumns);
